module.exports = __webpack_public_path__ + "static/media/fleche-gauche.bfb6a9bb.png";